function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Fragment, PureComponent } from 'react';
import Label from "semantic-ui-react/dist/es/elements/Label/Label.js";
import GridColumn from "semantic-ui-react/dist/es/collections/Grid/GridColumn.js";
import GridRow from "semantic-ui-react/dist/es/collections/Grid/GridRow.js";
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { Grid } from "../../layout/Grid";
import { Heading } from "../../typography/Heading";
import { FlexContainer } from "../../layout/FlexContainer";
import { Paragraph } from "../../typography/Paragraph";
import { getToggledIsActiveState } from "../../../utils/get-toggled-is-active-state";
export var Component = function (_PureComponent) {
  _inherits(Component, _PureComponent);

  var _super = _createSuper(Component);

  function Component() {
    var _this;

    _classCallCheck(this, Component);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isActive: false
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (previousProps, previousState) {
      var isActive = _this.state.isActive;
      if (previousState.isActive === isActive) return;
      var _this$props = _this.props,
          name = _this$props.name,
          onChange = _this$props.onChange;
      onChange(name, isActive);
    });

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (syntheticEvent) {
      var _this$props2 = _this.props,
          name = _this$props2.name,
          onClick = _this$props2.onClick;
      onClick(name, syntheticEvent);
    });

    _defineProperty(_assertThisInitialized(_this), "toggleActive", function () {
      return _this.setState(getToggledIsActiveState);
    });

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var _this$props3 = _this.props,
          hasShadow = _this$props3.hasShadow,
          isActive = _this$props3.isActive,
          isPointing = _this$props3.isPointing,
          onClick = _this$props3.onClick,
          periodText = _this$props3.periodText,
          pricePerPeriod = _this$props3.pricePerPeriod,
          pricePerPeriodPrefix = _this$props3.pricePerPeriodPrefix;
      return React.createElement("div", {
        className: classnames('ui', 'label', 'price-label', {
          active: isActive || _this.state.isActive,
          'is-clickable': onClick !== Function.prototype,
          'is-pointing': isPointing,
          'has-period-text': periodText
        }),
        onClick: _this.handleClick,
        onMouseOut: _this.toggleActive,
        onMouseOver: _this.toggleActive
      }, React.createElement(Label, null, !!pricePerPeriod && !periodText ? React.createElement(Grid, {
        className: classnames({
          active: isActive || _this.state.isActive,
          'is-pointing': isPointing
        })
      }, React.createElement(GridColumn, null, React.createElement(GridRow, null, React.createElement(Heading, {
        size: "medium"
      }, pricePerPeriod)), React.createElement(GridRow, null, isPointing && React.createElement("div", {
        className: classnames('pointer-arrow', 'is-pointing', {
          active: isActive || _this.state.isActive,
          'has-shadow': hasShadow
        })
      })))) : React.createElement(Fragment, null, React.createElement(Grid, {
        className: classnames({
          active: isActive || _this.state.isActive,
          'has-period-text': periodText,
          'is-pointing': isPointing
        })
      }, React.createElement(GridColumn, null, React.createElement(FlexContainer, {
        alignItems: "center",
        flexDirection: "row",
        justifyContent: "center"
      }, React.createElement(Paragraph, null, pricePerPeriodPrefix), React.createElement(Heading, {
        size: "medium"
      }, pricePerPeriod)), React.createElement(Label, null, periodText))), isPointing && React.createElement("div", {
        className: classnames('pointer-arrow', 'is-pointing', {
          active: isActive || _this.state.isActive,
          'has-shadow': hasShadow
        })
      }), isPointing && React.createElement("div", {
        className: classnames('label-shadow', 'is-pointing', {
          active: isActive || _this.state.isActive,
          'has-shadow': hasShadow
        })
      }))));
    });

    return _this;
  }

  return Component;
}(PureComponent);
Component.displayName = 'PriceLabel';
Component.defaultProps = {
  hasShadow: false,
  isActive: false,
  isPointing: false,
  name: undefined,
  onChange: Function.prototype,
  onClick: Function.prototype,
  periodText: '',
  pricePerPeriod: '',
  pricePerPeriodPrefix: ''
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  hasShadow: PropTypes.bool,
  isActive: PropTypes.bool,
  isPointing: PropTypes.bool,
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  periodText: PropTypes.string,
  pricePerPeriod: PropTypes.string,
  pricePerPeriodPrefix: PropTypes.string
} : {};